import { Typography } from 'Components/atoms';

export interface GroupedProgressHeaderProps {
    title: string;
    subtitle?: string;
}

export const GroupedProgressHeader = ({ title, subtitle }: GroupedProgressHeaderProps) => (
    <div className="grouped-progress__header">
        <Typography variant="subtitle1" color="text-high-emphasis" className="grouped-progress__title">
            {title}
        </Typography>
        {subtitle && (
            <Typography variant="subtitle3" color="text-medium-emphasis" className="grouped-progress__subtitle">
                {subtitle}
            </Typography>
        )}
    </div>
);

export default GroupedProgressHeader;
